import axios from "axios";
export default axios.create({
  baseURL: process.env.VUE_APP_ENDPOINT,
  //crossdomain: true,
  //timeout: 1000,
  headers: {
    "Content-Type": "application/json",
  },
});
